// extracted by mini-css-extract-plugin
export default {"placeholder":"styles_placeholder__UFdFi","add-bank-button":"styles_add-bank-button__-nz8W"};